// src/store/actions.js
// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_NAV_TYPE = '@customization/SET_NAV_TYPE'; //ESTA CONSTANTE SE UTILIZA PARA DEFINIR EL TIPO DE NAVEGACIÓN (MODO DE COLOR) EN LA APLICACIÓN, Y SE UTILIZA EN EL REDUCER PARA ACTUALIZAR EL ESTADO CUANDO SE CAMBIA EL MODO DE COLOR.
export const SET_CONTRAST_LEVEL = '@customization/SET_CONTRAST_LEVEL'; //ESTA CONSTANTE SE UTILIZA PARA DEFINIR EL NIVEL DE CONTRASTE EN LA APLICACIÓN, Y SE UTILIZA EN EL REDUCER PARA ACTUALIZAR EL ESTADO CUANDO SE CAMBIA EL NIVEL DE CONTRASTE.
